import { api, tr } from './shared';

export function getIntegrationsSections(lang) {
  return [
    {
      id: 'moysklad-overview',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navOrder: 0,
      navLabel: tr(lang, 'Обзор', 'Overview'),
      title: tr(lang, 'МойСклад (Loyalty API) — обзор', 'MoySklad (Loyalty API) — overview'),
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'МойСклад вызывает наш Loyalty API для поиска покупателя, получения баланса, пересчёта и фиксации продажи/возврата. Для вызовов Loyalty API нужен токен интеграции.',
            'MoySklad calls our Loyalty API to find customers, get balance, recalc and commit sale/return. Loyalty API calls require an integration token.',
          ),
        },
        {
          type: 'list',
          title: tr(lang, 'Loyalty Base URL', 'Loyalty Base URL'),
          items: [`${api.moyskladLoyalty}`],
        },
        {
          type: 'list',
          title: tr(lang, 'Заголовки Loyalty API', 'Loyalty API headers'),
          items: ['Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>'],
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Токен интеграции выдаётся при создании/ротации и хранится у вас. В нашей БД он хранится только в виде хеша.',
            'The integration token is issued on create/rotate and must be stored by you. We store only its hash in our DB.',
          ),
        },
      ],
    },
    {
      id: 'moysklad-integration-create',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 10,
      navLabel: tr(lang, 'Создать интеграцию (токен)', 'Create integration (token)'),
      title: 'POST /moysklad/integration',
      blocks: [
        { type: 'text', value: tr(lang, 'Создаёт интеграцию и возвращает токен (показывается один раз).', 'Creates integration and returns a token (shown once).') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '403 — нет доступа', '403 — forbidden'), tr(lang, '409 — конфликт состояния', '409 — conflict')] },
        {
          type: 'code',
          title: tr(lang, 'Тело запроса', 'Request body'),
          key: 'ms-int-create-body',
          value: `{\n  "card_id": "<CARD_UUID>",\n  "auto_issue_card": true,\n  "is_active": true\n}`,
        },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-int-create',
          value: `curl -X POST "${api.host}/moysklad/integration" \\\n  -H "Content-Type: application/json" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -d '{\n    "card_id": "<CARD_UUID>",\n    "auto_issue_card": true,\n    "is_active": true\n  }'`,
        },
        {
          type: 'text',
          value: tr(
            lang,
            'Если интеграция для карты уже существует, повторное создание вернёт HTTP 409. Используйте ротацию токена.',
            'If an integration for the card already exists, repeat create returns HTTP 409. Use token rotation.',
          ),
        },
      ],
    },
    {
      id: 'moysklad-integration-by-org',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 15,
      navLabel: tr(lang, 'Интеграция по организации', 'Integration by organization'),
      title: 'GET|POST|PUT /moysklad/integration/organization/{org_id}',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Предпочтительный org-level API. POST создаёт интеграцию и возвращает секрет; POST .../rotate ротирует токен. Card-level пути сохранены для совместимости.',
            'Preferred organization-level API. POST creates the integration and returns the secret; POST .../rotate rotates the token. Card-level paths remain for compatibility.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        {
          type: 'list',
          title: tr(lang, 'Методы', 'Methods'),
          items: [
            'GET /moysklad/integration/organization/{org_id}',
            'POST /moysklad/integration/organization/{org_id}',
            'PUT /moysklad/integration/organization/{org_id}',
            'POST /moysklad/integration/organization/{org_id}/rotate',
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-int-by-org',
          value: `curl -X GET "${api.host}/moysklad/integration/organization/<ORG_UUID>" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'moysklad-integration-by-card',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 20,
      navLabel: tr(lang, 'Интеграция по карте (legacy)', 'Integration by card (legacy)'),
      title: 'GET /moysklad/integration/card/{card_id}',
      blocks: [
        { type: 'text', value: tr(lang, 'Legacy: настройки интеграции для карты (без токена). Для новых интеграций используйте /integration/organization/{org_id}.', 'Legacy: integration settings for a card (without token). For new integrations use /integration/organization/{org_id}.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['card_id (string, CARD_UUID)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '403 — нет доступа', '403 — forbidden'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-int-by-card',
          value: `curl -X GET "${api.host}/moysklad/integration/card/<CARD_UUID>" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'moysklad-integration-update',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 30,
      navLabel: tr(lang, 'Обновить настройки', 'Update settings'),
      title: 'PUT /moysklad/integration/{integration_id}',
      blocks: [
        { type: 'text', value: tr(lang, 'Обновляет настройки интеграции (например auto_issue_card).', 'Updates integration settings (e.g., auto_issue_card).') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['integration_id (int)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '403 — нет доступа', '403 — forbidden'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'code',
          title: tr(lang, 'Тело запроса', 'Request body'),
          key: 'ms-int-update-body',
          value: `{\n  "auto_issue_card": true,\n  "is_active": true\n}`,
        },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-int-update',
          value: `curl -X PUT "${api.host}/moysklad/integration/<INTEGRATION_ID>" \\\n  -H "Content-Type: application/json" \\\n  -H "Authorization: Bearer <USER_TOKEN>" \\\n  -d '{\n    "auto_issue_card": true,\n    "is_active": true\n  }'`,
        },
      ],
    },
    {
      id: 'moysklad-integration-rotate',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Управление интеграцией', 'Integration management'),
      navSubgroupOrder: 10,
      navOrder: 40,
      navLabel: tr(lang, 'Ротация токена', 'Rotate token'),
      title: 'POST /moysklad/integration/{integration_id}/rotate',
      blocks: [
        { type: 'text', value: tr(lang, 'Перевыпускает токен интеграции и возвращает его (показывается один раз).', 'Reissues integration token and returns it (shown once).') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Authorization: Bearer <USER_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры пути', 'Path params'), items: ['integration_id (int)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '403 — нет доступа', '403 — forbidden'), tr(lang, '404 — не найдено', '404 — not found')] },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-int-rotate',
          value: `curl -X POST "${api.host}/moysklad/integration/<INTEGRATION_ID>/rotate" \\\n  -H "Authorization: Bearer <USER_TOKEN>"`,
        },
      ],
    },
    {
      id: 'moysklad-loyalty-counterparty-create',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Loyalty API', 'Loyalty API'),
      navSubgroupOrder: 20,
      navOrder: 10,
      navLabel: tr(lang, 'Создать/обновить покупателя', 'Upsert counterparty'),
      title: 'POST /moysklad/loyalty/counterparty',
      blocks: [
        { type: 'text', value: tr(lang, 'Создаёт или обновляет покупателя на нашей стороне и связывает с ms_counterparty_id.', 'Creates/updates a customer and links to ms_counterparty_id.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'code',
          title: tr(lang, 'Пример запроса', 'Example request'),
          key: 'ms-loyalty-counterparty',
          value: `curl -X POST "${api.moyskladLoyalty}/counterparty" \\\n  -H "Content-Type: application/json" \\\n  -H "Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>" \\\n  -d '{\n    "meta": { "id": "<COUNTERPARTY_ID>" },\n    "retailStore": { "meta": { "id": "<RETAIL_STORE_ID>" } },\n    "name": "Иванов Иван",\n    "phone": "+79990001122",\n    "email": "ivanov@example.com"\n  }'`,
        },
      ],
    },
    {
      id: 'moysklad-loyalty-counterparty-search',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Loyalty API', 'Loyalty API'),
      navSubgroupOrder: 20,
      navOrder: 20,
      navLabel: tr(lang, 'Поиск покупателя', 'Search counterparty'),
      title: 'GET /moysklad/loyalty/counterparty',
      blocks: [
        { type: 'text', value: tr(lang, 'Поиск покупателя по телефону (параметр search).', 'Search customer by phone (search parameter).') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры запроса', 'Query params'), items: ['search (string)', 'retailStoreId (string, required)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-loyalty-counterparty-search',
          value: `curl -X GET "${api.moyskladLoyalty}/counterparty?search=7999&retailStoreId=<RETAIL_STORE_ID>" \\\n  -H "Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>"`,
        },
      ],
    },
    {
      id: 'moysklad-loyalty-counterparty-detail',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Loyalty API', 'Loyalty API'),
      navSubgroupOrder: 20,
      navOrder: 30,
      navLabel: tr(lang, 'Детали (баланс)', 'Detail (balance)'),
      title: 'POST /moysklad/loyalty/counterparty/detail',
      blocks: [
        { type: 'text', value: tr(lang, 'Возвращает бонусный баланс (cashback) покупателя.', 'Returns customer bonus balance (cashback).') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-loyalty-counterparty-detail',
          value: `curl -X POST "${api.moyskladLoyalty}/counterparty/detail" \\\n  -H "Content-Type: application/json" \\\n  -H "Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>" \\\n  -d '{\n    "meta": { "id": "<COUNTERPARTY_ID>" },\n    "name": "Иванов Иван",\n    "phone": "+79990001122",\n    "email": "ivanov@example.com"\n  }'`,
        },
      ],
    },
    {
      id: 'moysklad-loyalty-recalc',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Loyalty API', 'Loyalty API'),
      navSubgroupOrder: 20,
      navOrder: 40,
      navLabel: tr(lang, 'Пересчёт продажи', 'Recalc demand'),
      title: 'POST /moysklad/loyalty/retaildemand/recalc',
      blocks: [
        { type: 'text', value: tr(lang, 'Пересчитывает списание/начисление по позициям и возвращает обогащённый payload с bonusProgram.', 'Recalculates spend/earn and returns enriched payload with bonusProgram.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-loyalty-recalc',
          value: `curl -X POST "${api.moyskladLoyalty}/retaildemand/recalc" \\\n  -H "Content-Type: application/json" \\\n  -H "Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>" \\\n  -d '{\n    "meta": { "id": "<RETAILD_DEMAND_ID>" },\n    "positions": []\n  }'`,
        },
      ],
    },
    {
      id: 'moysklad-loyalty-verify',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Loyalty API', 'Loyalty API'),
      navSubgroupOrder: 20,
      navOrder: 50,
      navLabel: tr(lang, 'Подтверждение списания', 'Verify spend'),
      title: 'POST /moysklad/loyalty/retaildemand/verify',
      blocks: [
        {
          type: 'text',
          value: tr(
            lang,
            'Возвращает verificationCode для подтверждения списания. В тестовом контуре Loyalclub отдаёт фиксированный код. Боевой OTP подключается на стороне Loyalclub; без него метод отвечает 412.',
            'Returns a verificationCode to confirm spend. In the Loyalclub test contour the method returns a fixed code. Production OTP is enabled by Loyalclub; without it the method responds 412.',
          ),
        },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Тело запроса', 'Request body'), items: ['phone (string, required)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized'), tr(lang, '412 — предусловие не выполнено', '412 — precondition failed')] },
        {
          type: 'list',
          title: tr(lang, 'Режимы работы', 'Modes'),
          items: [
            tr(lang, 'Тестовый контур — фиксированный verificationCode (его сообщает Loyalclub при подключении)', 'Test contour — a fixed verificationCode (Loyalclub shares it during onboarding)'),
            tr(lang, 'Боевой контур без подключённого OTP — HTTP 412', 'Production without OTP configured — HTTP 412'),
          ],
        },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-loyalty-verify',
          value: `curl -X POST "${api.moyskladLoyalty}/retaildemand/verify" \\\n  -H "Content-Type: application/json" \\\n  -H "Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>" \\\n  -d '{\n    "phone": "+79990001122"\n  }'`,
        },
      ],
    },
    {
      id: 'moysklad-loyalty-sale',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Loyalty API', 'Loyalty API'),
      navSubgroupOrder: 20,
      navOrder: 60,
      navLabel: tr(lang, 'Зафиксировать продажу', 'Commit demand'),
      title: 'POST /moysklad/loyalty/retaildemand',
      blocks: [
        { type: 'text', value: tr(lang, 'Фиксирует продажу (начисление/списание) и делает операцию идемпотентной по meta.id.', 'Commits sale (earn/spend) and is idempotent by meta.id.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-loyalty-sale',
          value: `curl -X POST "${api.moyskladLoyalty}/retaildemand" \\\n  -H "Content-Type: application/json" \\\n  -H "Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>" \\\n  -d '{\n    "meta": { "id": "<RETAILD_DEMAND_ID>" },\n    "sum": 2400\n  }'`,
        },
      ],
    },
    {
      id: 'moysklad-loyalty-return',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Loyalty API', 'Loyalty API'),
      navSubgroupOrder: 20,
      navOrder: 70,
      navLabel: tr(lang, 'Зафиксировать возврат', 'Commit return'),
      title: 'POST /moysklad/loyalty/retailsalesreturn',
      blocks: [
        { type: 'text', value: tr(lang, 'Фиксирует возврат и делает операцию идемпотентной по meta.id.', 'Commits return and is idempotent by meta.id.') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-loyalty-return',
          value: `curl -X POST "${api.moyskladLoyalty}/retailsalesreturn" \\\n  -H "Content-Type: application/json" \\\n  -H "Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>" \\\n  -d '{\n    "meta": { "id": "<RETAIL_RETURN_ID>" },\n    "sum": 1200\n  }'`,
        },
      ],
    },
    {
      id: 'moysklad-loyalty-giftcard',
      category: tr(lang, 'Интеграции', 'Integrations'),
      navGroup: tr(lang, 'МойСклад (Loyalty API)', 'MoySklad (Loyalty API)'),
      navGroupOrder: 10,
      navSubgroup: tr(lang, 'Loyalty API', 'Loyalty API'),
      navSubgroupOrder: 20,
      navOrder: 80,
      navLabel: tr(lang, 'Подарочная карта', 'Gift card'),
      title: 'GET /moysklad/loyalty/giftcard',
      blocks: [
        { type: 'text', value: tr(lang, 'Поиск подарочного сертификата по номеру (name).', 'Find gift card by number (name).') },
        { type: 'list', title: tr(lang, 'Заголовки', 'Headers'), items: ['Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>'] },
        { type: 'list', title: tr(lang, 'Параметры запроса', 'Query params'), items: ['name (string, required)', 'retailStoreId (string, required)'] },
        { type: 'list', title: tr(lang, 'Коды ответов', 'Response codes'), items: [tr(lang, '200 — успешно', '200 — success'), tr(lang, '401 — не авторизован', '401 — unauthorized')] },
        {
          type: 'code',
          title: 'curl',
          key: 'ms-loyalty-giftcard',
          value: `curl -X GET "${api.moyskladLoyalty}/giftcard?name=<CARD_NUMBER>&retailStoreId=<RETAIL_STORE_ID>" \\\n  -H "Lognex-Discount-API-Auth-Token: <MOYSKLAD_TOKEN>"`,
        },
      ],
    },
  ];
}
